var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 34,
    viewBox: "0 0 48 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2026 14.9283C39.183 6.89699 32.3066 0.666992 24 0.666992C17.5693 0.666992 11.9833 4.42366 9.43296 10.348C4.42096 11.8483 0.666626 16.5803 0.666626 21.667C0.666626 27.8667 5.54096 32.902 11.652 33.266V33.3337H37.9766V33.3267L38 33.3337C43.1473 33.3337 47.3333 29.1477 47.3333 24.0003C47.3305 21.9085 46.6266 19.8781 45.3339 18.2335C44.0413 16.5889 42.2346 15.4252 40.2026 14.9283ZM14.6666 17.0003H21.6666V10.0003H26.3333V17.0003H33.3333L24 28.667L14.6666 17.0003Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhoto);
export default __webpack_public_path__ + "static/media/UploadPhoto.9f25d539.svg";
export { ForwardRef as ReactComponent };